import React from 'react';


const RenderChips = ({langs: items, type, large}) => {
	if (!items || items.length === 0) return null;
	
	let chipClass = type === 'lang' ? 'lang-chip' : 'software-chip';
    let chipStr = 'chip';
    if(large)
        chipStr+= '-large'
	return (
		<div className="chips-container">
			{items.map((item, index) => (
				<span 
					key={`${type}-${index}`} 
					className={`${chipStr} ${chipClass}`}
				>
					{item}
				</span>
			))}
		</div>
	);
};


export default RenderChips;